import { useMemo } from 'react';
import uuid from 'uuid';
import { extractBlockProps as extractCardProps } from '../../extractors/block';
import { useSmartCardActions as useLinkActions } from '../actions';
import { useSmartLinkAnalytics as useLinkAnalytics } from '../analytics';
import { useSmartCardState as useLinkState } from '../store';
import { getExtensionKey } from '../helpers';
export function useSmartLinkActions({
  url,
  appearance,
  analyticsHandler,
  platform = 'web',
  origin,
  actionOptions
}) {
  const id = useMemo(() => uuid(), []);
  const linkState = useLinkState(url);
  const linkAnalytics = useLinkAnalytics(url, analyticsHandler, id);
  const linkActions = useLinkActions(id, url, linkAnalytics);
  if (linkState.details && !(actionOptions !== null && actionOptions !== void 0 && actionOptions.hide)) {
    const cardProperties = extractCardProps(linkState.details.data, linkState.details.meta, {
      handleInvoke: opts => linkActions.invoke(opts, appearance),
      analytics: linkAnalytics,
      origin,
      extensionKey: getExtensionKey(linkState.details),
      source: appearance,
      actionOptions
    }, undefined, platform);
    if (cardProperties.actions && cardProperties.actions.length > 0) {
      const cardActions = cardProperties.actions.map(action => ({
        id: action.id,
        text: action.text,
        invoke: action.promise
      }));
      return cardActions;
    }
  }
  return [];
}